module.exports = {
	Telemetry: require("./Telemetry").default
}